import Vue from 'vue';
import VueQuillEditor from 'vue-quill-editor';
import VueVirtualScroller from 'vue-virtual-scroller';
import VeeValidate from 'vee-validate';
import VueSocketIO from 'vue-socket.io';
import Datetime from 'vue-datetime';
import pl from 'vee-validate/dist/locale/pl';

import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import 'video.js/dist/video-js.css';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import 'vue-datetime/dist/vue-datetime.css';
import VueMask from 'v-mask';

import App from './App.vue';
import { router } from './router/router';
import { store } from './store/store';
import { i18n } from './i18n/i18n';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;

Vue.use(VeeValidate, {
  i18nRootKey: 'validations',
  i18n,
  dictionary: {
    pl,
  },
});

Vue.use(new VueSocketIO({
  connection: process.env.VUE_APP_SOCKET_URL,
  options: {
    autoConnect: false,
    query: {
      token: null,
    },
  },
}));

Vue.use(VueQuillEditor);
Vue.use(VueVirtualScroller);
Vue.use(Datetime);
Vue.use(VueMask);

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App),
}).$mount('#app');
